export default "__VITE_ASSET__tHLvVU7j__"